export const GET_TRAIL_PLAN = 'GET_TRAIL_PLAN';

export const GET_TRAIL_PLANS = 'GET_TRAIL_PLANS';

export const UPDATE_TRAIL_PLANS = 'UPDATE_TRAIL_PLANS';

export const GET_GAME = 'GET_GAME';
